<template>
    <v-container fluid>
        <v-row no-gutters class="d-block">
            <v-col cols="12" sm="12" md="12" lg="12" xl="12">
                <v-card>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12" sm="6" md="6" lg="6" xl="6">
                                <v-text-field
                                    :value="importacionMaestro.numero"
                                    label="Número de Importación"
                                    readonly
                                    prepend-icon="pin"
                                />

                                <v-text-field
                                    :value="importacionMaestro.unidad_operativa"
                                    label="Unidad Operativa"
                                    readonly
                                    prepend-icon="business"
                                />

                                <v-text-field
                                    :value="importacionMaestro.archivo_nombre"
                                    label="Archivo"
                                    readonly
                                    prepend-icon="attach_file"
                                />

                                <v-text-field
                                    :value="rangoRegistros"
                                    label="Números de registro de esta importación"
                                    readonly
                                    prepend-icon="confirmation_number"
                                    :hint="rangoConsecutivo ? '' : 'Los números no son consecutivos: hay saltos dentro del rango.'"
                                    persistent-hint
                                />
                            </v-col>

                            <v-col cols="12" sm="6" md="6" lg="6" xl="6">
                                <v-text-field
                                    :value="importacionMaestro.nombres_apellidos"
                                    label="Importada por"
                                    readonly
                                    prepend-icon="person"
                                />

                                <v-text-field
                                    :value="importacionMaestro.fecha_crea | fechaESPHora"
                                    label="Fecha de Importación"
                                    readonly
                                    prepend-icon="today"
                                />

                                <v-text-field
                                    :value="importacionMaestro.fecha_actualiza | fechaESPHora"
                                    label="Fecha de Procesamiento"
                                    readonly
                                    prepend-icon="today"
                                />
                            </v-col>
                        </v-row>

                        <v-expansion-panels accordion v-model="panel" multiple>
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <v-toolbar-title>Datos de la Importación</v-toolbar-title>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-row>

                                        <v-col cols="6" sm="6" md="6" lg="6" xl="6">

                                            <v-btn color="info" outlined small @click="importacionDetalleGet()">
                                                <v-icon>refresh</v-icon>
                                                Refrescar
                                            </v-btn>

                                        </v-col>

                                        <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pt-0">
                                            <buscador-campos
                                                ref="buscador"
                                                :cargando="loading"
                                                :ancho-selector="{sm: 5, md: 5}"
                                                :ancho-campo="{sm: 7, md: 7}"
                                                @buscar="buscar"
                                                @limpiar="buscar({texto: '', campo: 'todos', persona: null})"
                                            />
                                        </v-col>

                                        <v-col cols="12">
                                            <v-data-table
                                                dense
                                                class="elevation-1"
                                                :headers="tableHeaders"
                                                :items="importacionDetalle"
                                                :loading="loading"
                                                item-key="curso_id"
                                                fixed-header
                                                height="65vh"
                                                :hide-default-footer="true"
                                                disable-pagination
                                            >
                                                <template v-slot:item="{ item }">
                                                    <tr>
                                                        <td class="text-left text-no-wrap" v-html="resaltar(item.numero_identidad, 'identidad')"></td>
                                                        <td class="text-left" v-html="resaltar(item.nombres_apellidos, 'nombre')"></td>
                                                        <td class="text-left" v-html="resaltar(item.registro, 'registro')"></td>
                                                        <td class="text-left">
                                                            <span v-html="resaltar(item.curso, 'curso')"></span>
                                                            <div class="text-caption grey--text text--darken-1"
                                                                 v-if="item.codigo_curricula || item.plataforma || item.nombre_exacto"
                                                                 :title="item.nombre_exacto ? 'Nombre exacto: ' + item.nombre_exacto : ''">
                                                                <v-icon x-small>fact_check</v-icon>
                                                                {{ [item.codigo_curricula, item.plataforma].filter(Boolean).join(' · ') || item.nombre_exacto }}
                                                            </div>
                                                        </td>
                                                        <td class="text-left">{{ item.fecha_inicio | fechaESP }}</td>
                                                        <td class="text-left">{{
                                                                item.fecha_finalizacion | fechaESP
                                                            }}
                                                        </td>
                                                        <td class="text-left">{{
                                                                item.fecha_certificado | fechaESP
                                                            }}
                                                        </td>
                                                        <td class="text-center">
                                                            <v-chip
                                                                :color="(item.aprobado) ? 'success' : 'error'"
                                                                outlined
                                                                pill
                                                            >
                                                                {{ item.nota }}
                                                            </v-chip>
                                                        </td>
                                                        <td class="text-left">{{ item.tutor }}</td>
                                                    </tr>
                                                </template>
                                                <template v-slot:no-data>
                                                    <v-alert dense type="warning" outlined class="text-center mt-3">
                                                        No existen registros.
                                                    </v-alert>
                                                </template>

                                            </v-data-table>
                                            <Pagination :pagination="pagination" @setCambiarPagina="setCambiarPagina"
                                                        v-if="pagination.total"/>
                                        </v-col>

                                    </v-row>
                                </v-expansion-panel-content>
                            </v-expansion-panel>

                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <div class="d-flex align-center flex-wrap">
                                        <v-toolbar-title>Video de felicitación</v-toolbar-title>
                                        <v-chip small outlined class="ml-3"
                                                :color="importacionMaestro.video_nombre ? (importacionMaestro.video_activo ? 'success' : 'grey') : 'grey'">
                                            <v-icon small left>{{ importacionMaestro.video_nombre ? (importacionMaestro.video_activo ? 'play_circle' : 'pause_circle') : 'videocam_off' }}</v-icon>
                                            {{ importacionMaestro.video_nombre ? (importacionMaestro.video_activo ? 'Activo' : 'Inactivo') : 'Sin video' }}
                                        </v-chip>
                                    </div>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <p class="text-body-2 grey--text text--darken-1 mb-4">
                                        Cada participante de esta promoción verá el video completo al presionar
                                        <b>Descargar certificado</b>; al terminar se le muestra su certificado.
                                        Formato MP4, máximo 60 segundos y 50 MB.
                                    </p>
                                    <v-row>
                                        <v-col cols="12" md="6" v-if="importacionMaestro.video_url">
                                            <video
                                                :key="importacionMaestro.video_url"
                                                :src="importacionMaestro.video_url"
                                                controls preload="metadata"
                                                class="video-previa"
                                            ></video>
                                            <div class="text-caption grey--text text--darken-1 mt-1 text-truncate" :title="importacionMaestro.video_nombre">
                                                <v-icon x-small>movie</v-icon> {{ importacionMaestro.video_nombre }}
                                            </div>
                                            <v-switch
                                                v-model="importacionMaestro.video_activo"
                                                color="success" inset dense hide-details
                                                :disabled="videoCargando"
                                                :label="importacionMaestro.video_activo ? 'Se muestra a los participantes' : 'Desactivado: no se muestra'"
                                                @change="videoActivar"
                                            />
                                            <div class="mt-3">
                                                <v-btn v-if="!confirmarQuitarVideo" small outlined color="error" :disabled="videoCargando" @click="confirmarQuitarVideo = true">
                                                    <v-icon small left>delete</v-icon> Quitar video
                                                </v-btn>
                                                <template v-else>
                                                    <span class="text-body-2 mr-2">¿Quitar el video de esta promoción?</span>
                                                    <v-btn small color="error" :loading="videoCargando" @click="videoEliminar">Sí, quitar</v-btn>
                                                    <v-btn small text @click="confirmarQuitarVideo = false">Cancelar</v-btn>
                                                </template>
                                            </div>
                                        </v-col>

                                        <v-col cols="12" md="6">
                                            <v-file-input
                                                v-model="videoArchivo"
                                                accept="video/mp4,.mp4"
                                                :label="importacionMaestro.video_url ? 'Seleccionar otro video (MP4)' : 'Seleccionar video (MP4)'"
                                                prepend-icon="videocam"
                                                show-size outlined dense
                                                :disabled="videoCargando"
                                                @change="videoSeleccionado"
                                            />
                                            <div v-if="videoDuracion && !videoError" class="text-caption grey--text text--darken-1 mb-2">
                                                <v-icon x-small>schedule</v-icon> Duración: {{ Math.round(videoDuracion) }} segundos
                                            </div>
                                            <v-alert v-if="videoError" dense text type="error" class="mb-2">{{ videoError }}</v-alert>
                                            <v-progress-linear v-if="videoCargando" :value="videoProgreso" color="success" height="6" rounded class="mb-2"/>
                                            <v-btn color="success" small
                                                   :disabled="!videoArchivo || !!videoError || videoCargando"
                                                   :loading="videoCargando"
                                                   @click="videoSubir">
                                                <v-icon left small>cloud_upload</v-icon>
                                                {{ importacionMaestro.video_url ? 'Reemplazar video' : 'Subir video' }}
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-content>
                            </v-expansion-panel>

                            <v-expansion-panel v-if="importacionMaestro.puede_eliminar">
                                <v-expansion-panel-header>
                                    <v-toolbar-title>
                                        ¿Quiere Eliminar esta Importación <b>{{importacionMaestro.numero}}</b>?. Esta operación Eliminará toda la Data Importada.
                                    </v-toolbar-title>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-form ref="form" v-model="valid">

                                        <v-text-field
                                            v-model="importacionModel.observacion"
                                            :label="importacionForm.observacion.label"
                                            :rules="importacionForm.observacion.rules"
                                            required
                                            prepend-icon="description"
                                        />

                                    </v-form>
                                    <v-divider class="mt-1"></v-divider>
                                    <div class="text-center py-3">

                                        <v-btn small color="error" :loading="loading"
                                               @click.stop="eliminarImportacion()" :disabled="!valid">
                                            <v-icon>delete</v-icon>
                                            SI, Eliminar, estoy de Acuerdo
                                        </v-btn>

                                    </div>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>


                    </v-card-text>
                    <v-divider class="mt-1"></v-divider>
                    <v-card-actions class="justify-center py-3">

                        <v-btn small outlined @click="regresar">
                            <v-icon>arrow_back</v-icon>
                            Regresar
                        </v-btn>

                    </v-card-actions>
                </v-card>

            </v-col>
        </v-row>

    </v-container>
</template>

<script>
import Auth from "@/services/auth";
const Pagination = () => import("@/pages/Components/Pagination.vue");
import BuscadorCampos from "@/components/Buscador/BuscadorCampos.vue";

export default {
    name: "AdministracionImportacionesVer",
    components: {Pagination, BuscadorCampos},
    data() {
        return {
            permisos: [],
            search: "",
            campo: "todos",
            secuenciaConsulta: 0,
            pagination: {},
            importacionDetalle: [],
            importacionMaestro: {},
            pageActual: 1,
            rowsPage: this.$store.state.arrayRowsPages[0],
            valid: true,
            loading: false,
            panel: [0, 1],
            videoArchivo: null,
            videoDuracion: null,
            videoError: "",
            videoCargando: false,
            videoProgreso: 0,
            confirmarQuitarVideo: false,
            tableHeaders: [
                {
                    text: 'Identidad',
                    value: 'numero_identidad',
                    align: 'left',
                    sortable: false,
                },
                {
                    text: 'Nombres Participante',
                    value: 'nombres_apellidos',
                    align: 'left',
                    sortable: false,
                },
                {
                    text: 'Registro',
                    value: 'registro',
                    align: 'left',
                    sortable: false,
                },
                {
                    text: 'Curso',
                    value: 'curso',
                    align: 'left',
                    sortable: false,
                },
                {
                    text: 'Fecha Inicio',
                    value: 'fecha_inicio',
                    align: 'left',
                    sortable: false,
                },
                {
                    text: 'Fecha Fin',
                    value: 'fecha_fin',
                    align: 'left',
                    sortable: false,
                },
                {
                    text: 'Fecha Certificado',
                    value: 'fecha_certificado',
                    align: 'left',
                    sortable: false,
                },
                {
                    text: 'Nota',
                    value: 'nota',
                    align: 'center',
                    sortable: false,
                },
                {
                    text: 'Tutor',
                    value: 'tutor',
                    align: 'left',
                    sortable: false,
                },
            ],
            importacionModel: {
                importacion_id: null,
                observacion: null,
            },
            importacionForm: {
                observacion: {
                    label: "Observación",
                    placeholder: 'Escriba una Observación para Eliminar',
                    rules: [
                        (v) => !!v || 'Campo requerido',
                        (v) => !!v && v.length >= 10 || `La Observación tiene que ser mayor a 10 caracteres.`,
                    ],
                },
            },
        }
    },
    computed: {
        rangoRegistros() {
            const m = this.importacionMaestro;
            if (!m || !m.registro_cantidad) return "Sin números de registro";
            const rango = m.registro_desde === m.registro_hasta ? `${m.registro_desde}` : `Del ${m.registro_desde} al ${m.registro_hasta}`;
            return `${rango}  ·  ${m.registro_cantidad} ${m.registro_cantidad === 1 ? 'registro' : 'registros'}`;
        },
        rangoConsecutivo() {
            const m = this.importacionMaestro;
            if (!m || !m.registro_cantidad) return true;
            return Number(m.registro_hasta) - Number(m.registro_desde) + 1 === Number(m.registro_cantidad);
        },
    },
    methods: {
        buscar(criterio) {
            this.search = criterio.texto;
            this.campo = criterio.campo;
            this.pageActual = 1;
            this.importacionDetalleGet();
        },
        resaltar(valor, columna) {
            const buscador = this.$refs.buscador;
            return buscador ? buscador.resaltar(valor, columna) : (valor || "");
        },
        importacionDetalleBuscar() {
            this.pageActual = 1;
            this.importacionDetalleGet();
        },
        importacionDetalleGet() {
            this.loading = true;
            const secuencia = ++this.secuenciaConsulta;

            let params = {
                importacion_id: this.importacionModel.importacion_id,
                busqueda: this.search,
                campo: this.campo,
                page: this.pageActual,
                rowsPage: this.rowsPage
            };

            window.axios.get('/cursos/por_importacion', {params}).then(response => {
                if (secuencia !== this.secuenciaConsulta) return;
                if (response.data.success) {

                    let data = response.data.data;
                    this.importacionDetalle = data.cursos.data;
                    this.pagination = data.pagination;

                } else if (response.data.success === false) {
                    this.$toast.error(response.data.message);
                }
            })
                .catch(error => {
                    console.log(error)
                    this.$toast.error("No se pudo listar datos.");
                })
                .finally(() => {
                    this.loading = false;
                })
        },
        importacionMaestroGet() {
            this.loading = true;

            let params = {
                importacion_id: this.importacionModel.importacion_id
            };

            window.axios.get('/importaciones/maestro', {params}).then(response => {
                if (response.data.success) {

                    let data = response.data.data;
                    this.importacionMaestro = data;

                } else if (response.data.success === false) {
                    this.$toast.error(response.data.message);
                }
            })
                .catch(error => {
                    console.log(error)
                    this.$toast.error("No se pudo listar datos.");
                })
                .finally(() => {
                    this.loading = false;
                })
        },
        eliminarImportacion() {
            this.loading = true;

            window.axios.post('/importaciones/delete', this.importacionModel).then(response => {
                if (response.data.success) {

                    this.$toast.success(response.data.message);
                    this.regresar();

                } else if (response.data.success === false) {
                    this.$toast.error(response.data.message);
                }
            })
                .catch(error => {
                    console.log(error)
                    this.$toast.error("No se pudo listar datos.");
                })
                .finally(() => {
                    this.loading = false;
                })
        },
        // ----- Video de felicitación -----
        aplicarVideo(datos) {
            this.importacionMaestro = {...this.importacionMaestro, ...datos};
            this.confirmarQuitarVideo = false;
        },
        videoSeleccionado(archivo) {
            this.videoError = "";
            this.videoDuracion = null;
            if (!archivo) return;

            const esMp4 = archivo.type === "video/mp4" || /\.mp4$/i.test(archivo.name);
            if (!esMp4) {
                this.videoError = "El video debe estar en formato MP4.";
                return;
            }
            if (archivo.size > 50 * 1024 * 1024) {
                this.videoError = "El video no puede superar 50 MB.";
                return;
            }

            // Se mide la duración en el navegador antes de subirlo.
            const url = URL.createObjectURL(archivo);
            const video = document.createElement("video");
            video.preload = "metadata";
            video.onloadedmetadata = () => {
                URL.revokeObjectURL(url);
                this.videoDuracion = video.duration;
                if (video.duration > 61) {
                    this.videoError = `El video dura ${Math.round(video.duration)} segundos; el máximo es 60.`;
                }
            };
            video.onerror = () => {
                URL.revokeObjectURL(url);
                this.videoError = "No se pudo leer el video. Verifique que sea un MP4 válido.";
            };
            video.src = url;
        },
        videoSubir() {
            if (!this.videoArchivo || this.videoError) return;

            const datos = new FormData();
            datos.append("importacion_id", this.importacionModel.importacion_id);
            datos.append("video", this.videoArchivo);
            if (this.videoDuracion) datos.append("duracion", this.videoDuracion.toFixed(1));

            this.videoCargando = true;
            this.videoProgreso = 0;

            window.axios.post('/importaciones/video', datos, {
                onUploadProgress: (e) => {
                    if (e.total) this.videoProgreso = Math.round((e.loaded * 100) / e.total);
                },
            }).then(response => {
                if (response.data.success) {
                    this.$toast.success(response.data.message);
                    this.aplicarVideo(response.data.data);
                    this.videoArchivo = null;
                    this.videoDuracion = null;
                } else {
                    this.$toast.error(response.data.message);
                }
            })
                .catch(error => this.videoErrorRespuesta(error, "No se pudo subir el video."))
                .finally(() => {
                    this.videoCargando = false;
                });
        },
        videoActivar(activo) {
            this.videoCargando = true;
            const params = {importacion_id: this.importacionModel.importacion_id, activo: activo ? 1 : 0};

            window.axios.post('/importaciones/video/activar', params).then(response => {
                if (response.data.success) {
                    this.$toast.success(response.data.message);
                    this.aplicarVideo(response.data.data);
                } else {
                    this.$toast.error(response.data.message);
                    this.importacionMaestro.video_activo = !activo;
                }
            })
                .catch(error => {
                    this.importacionMaestro.video_activo = !activo;
                    this.videoErrorRespuesta(error, "No se pudo cambiar el estado del video.");
                })
                .finally(() => {
                    this.videoCargando = false;
                });
        },
        videoEliminar() {
            this.videoCargando = true;
            const params = {importacion_id: this.importacionModel.importacion_id};

            window.axios.post('/importaciones/video/eliminar', params).then(response => {
                if (response.data.success) {
                    this.$toast.success(response.data.message);
                    this.aplicarVideo(response.data.data);
                } else {
                    this.$toast.error(response.data.message);
                }
            })
                .catch(error => this.videoErrorRespuesta(error, "No se pudo eliminar el video."))
                .finally(() => {
                    this.videoCargando = false;
                });
        },
        videoErrorRespuesta(error, mensaje) {
            console.log(error);
            const cuerpo = error.response && error.response.data;
            if (cuerpo && cuerpo.data && typeof cuerpo.data === "object") {
                const detalles = Object.values(cuerpo.data).flat().join(" ");
                if (detalles) mensaje = detalles;
            } else if (cuerpo && cuerpo.message) {
                mensaje = cuerpo.message;
            } else if (error.response && error.response.status === 413) {
                mensaje = "El servidor rechazó el archivo por su tamaño.";
            }
            this.$toast.error(mensaje);
        },
        setCambiarPagina(data) {
            this.pageActual = data.page;
            this.rowsPage = data.rowsPage;
            this.importacionDetalleGet();
        },
        verificarToken() {

            if (typeof this.$route.query.token !== "undefined") {
                try {
                    let token = this.$route.query.token;
                    this.importacionModel.importacion_id = window.atob(token);

                    this.importacionMaestroGet();
                    this.importacionDetalleGet();
                } catch (e) {
                    console.log(e);
                    this.$toast.error("El parametro para Ver no es valido.");
                    this.regresar();
                }

            } else {
                this.$toast.error("Debe enviar un parametro para Ver.");
                this.regresar();
            }
        },
        regresar() {
            this.$router.go(-1)
        }
    },
    created() {
        Auth.checkPermisos("/administracion/importaciones").then((res) => {
            this.permisos = res;
            this.verificarToken();
        });

    }
}
</script>

<style>
.video-previa {
    width: 100%;
    max-height: 320px;
    background: #000;
    border-radius: 8px;
    display: block;
}
</style>
